import translation from './translation.json';

const en = {
    translation,
};

export default en;
